import { render } from "./IconLink.vue?vue&type=template&id=0ebdbaf6&scoped=true"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"

import "./IconLink.vue?vue&type=style&index=0&id=0ebdbaf6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebdbaf6"]])

export default __exports__